import React, { useState, useEffect, useRef } from "react";
import ReactTable from "react-table";
import Button from "components/button/Button";
import Pagination from "components/common/Pagination";
import "react-table/react-table.css";
import { withRouter } from "react-router";
import GroupServices from "../../api/GroupServices";
import Loader from "../common/Loader";
import CommonModel from "../common/CommonModel";
import BenefitPeriodModal from "../group/BenefitPeriodModal";
//import Moment from "react-moment";
import Toaster from "../common/Toaster";
import { MODULE_NAMES, PERMISSION_TYPE, TABLE } from "../../helper/constant";
import EncryptDecrypt from "../../api/EncryptDecrypt";
import moment from "moment";
import { RD } from "helper/constant";
import { hasAccess } from "util/sidebar";

const BenefitPeriodTable = props => {
  const { permissions } = props;
  const [tblData, settblData] = useState();
  const [loader, setLoader] = useState(false);
  const [pages, setPages] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [field, setField] = useState("created_at");
  const [sortBy, setSortBy] = useState("DESC");
  const [id, setId] = useState(undefined);
  const [modal, setModal] = useState(undefined);
  const [editedData, setEditedData] = useState(undefined);

  const toaster = useRef();

  const hasParam = props.match.params.id;

  function toggle() {
    setModal(false);
  }

  const formAction = (action, data = null) => {
    // Here you can view the data and make forward action for edit data
    if (action === "edit") {
      setId(data.id);
      setModal(true);
      const params = {
        id: data.id
      };
      GroupServices.benefitPeriodView(params).then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        setEditedData(data.data);
      });
    } else if (action === "add") {
      setId(data);
      setModal(true);
      setEditedData(null);
    }
  };

  useEffect(() => {
    if (
      hasAccess(MODULE_NAMES.GROUP_BENEFIT, PERMISSION_TYPE.VIEW, permissions)
    ) {
      const params = {
        id: hasParam
      };
      getList(field, sortBy, searchText, activePage + 1);
      setPages(10);
    }
  }, []);

  const submitFormHandler = () => {
    setModal(false);
    setTimeout(() => {
      getList(field, sortBy, searchText, activePage + 1);
    }, 1000);
  };

  const autoRenewStatusHandler = oData => {
    const params = {
      auto_renew: !oData.auto_renew,
      id: oData.id
    };
    setLoader(true);
    GroupServices.benefitAutoRenewStatus(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          if (toaster.current)
            toaster.current.success(
              oData.auto_renew === true
                ? "Benefit Period auto renew has been disabled successfully."
                : "Benefit Period auto renew has been enabled successfully."
            );
          getList(field, sortBy, searchText, activePage + 1, 1);
          setLoader(false);
        } else {
          if (toaster.current) toaster.current.error(data.message);
          setLoader(false);
        }
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.response);
        setLoader(false);
      });
  };

  const activeInactiveStatusHandler = oData => {
    const params = {
      is_active: !oData.is_active,
      id: oData.id
    };
    setLoader(true);
    GroupServices.benefitActiveInactiveStatus(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          if (toaster.current)
            toaster.current.success(
              oData.is_active === true
                ? "Benefit Period has been deactivated successfully."
                : "Benefit Period has been activated successfully."
            );
          getList(field, sortBy, searchText, activePage + 1, 1);
          setLoader(false);
        } else {
          if (toaster.current) toaster.current.error(data.message);
          setLoader(false);
        }
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.response);
        setLoader(false);
      });
  };

  const columns = [
    {
      Header: "Start Date",
      accessor: "start_date",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      Cell: props => moment(props.original.start_date).format("MM/DD/YYYY"),
      sortable: true
    },
    {
      Header: "End Date",
      accessor: "end_date",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      Cell: props => moment(props.original.end_date).format("MM/DD/YYYY"),
      sortable: true
    },
    {
      Header: "Auto Renew",
      accessor: "auto_renew",
      className: "",
      headerClassName: "react-table-header-class sort-sign",
      sortable: true,
      filterable: false,
      Cell: cellProps => (
        <div className="react-action-class">
          {props.authData.adminRoleId !== RD ? (
            cellProps.original.auto_renew ? (
              <div id={`active-${cellProps.original.state_id}`}>
                <Button
                  style={{ minWidth: "80px" }}
                  className="c-btn c-info mr-10"
                  onClick={() => autoRenewStatusHandler(cellProps.original)}
                >
                  <div className="fs-14 medium-text">
                    <i className="fas fa-toggle-off mr-6" /> Enabled
                  </div>
                </Button>
              </div>
            ) : (
              <div id={`deactive-${cellProps.original.state_id}`}>
                <Button
                  style={{ minWidth: "80px" }}
                  className="c-btn c-warning mr-10"
                  onClick={() => autoRenewStatusHandler(cellProps.original)}
                >
                  <div className="fs-14 medium-text">
                    <i className="fas fa-toggle-on mr-6" /> Disabled
                  </div>
                </Button>
              </div>
            )
          ) : cellProps.original.is_active ? (
            "Active"
          ) : (
            "Inactive"
          )}
        </div>
      ) // Custom cell components!
    },
    {
      Header: "Status",
      accessor: "is_active",
      className: "",
      headerClassName: "react-table-header-class sort-sign",
      sortable: true,
      filterable: false,
      Cell: cellProps => (
        <div className="react-action-class">
          {props.authData.adminRoleId !== RD ? (
            cellProps.original.is_active ? (
              <div id={`active-${cellProps.original.state_id}`}>
                <Button
                  style={{ minWidth: "80px" }}
                  className="c-btn c-info mr-10"
                  onClick={() =>
                    activeInactiveStatusHandler(cellProps.original)
                  }
                  disabled={
                    !hasAccess(
                      MODULE_NAMES.GROUP_BENEFIT,
                      PERMISSION_TYPE.STATUS,
                      permissions
                    )
                  }
                >
                  <div className="fs-14 medium-text">
                    <i className="fas fa-toggle-off mr-6" /> Enabled
                  </div>
                </Button>
              </div>
            ) : (
              <div id={`deactive-${cellProps.original.state_id}`}>
                <Button
                  style={{ minWidth: "80px" }}
                  className="c-btn c-warning mr-10"
                  onClick={() =>
                    activeInactiveStatusHandler(cellProps.original)
                  }
                  disabled={
                    !hasAccess(
                      MODULE_NAMES.GROUP_BENEFIT,
                      PERMISSION_TYPE.STATUS,
                      permissions
                    )
                  }
                >
                  <div className="fs-14 medium-text">
                    <i className="fas fa-toggle-on mr-6" /> Disabled
                  </div>
                </Button>
              </div>
            )
          ) : cellProps.original.is_active ? (
            "Enabled"
          ) : (
            "Disabled"
          )}
        </div>
      ) // Custom cell components!
    }
  ];

  if (
    hasAccess(MODULE_NAMES.GROUP_BENEFIT, PERMISSION_TYPE.EDIT, permissions)
  ) {
    columns.push({
      Header: "Action",
      accessor: "action",
      className: "",
      headerClassName: "react-table-header-class",
      sortable: false,
      filterable: false,
      Cell: colProps => (
        <div className="react-action-class">
          <Button
            className="c-btn c-success mr-10"
            onClick={() => formAction("edit", colProps.original)}
          >
            <div className="fs-14 medium-text">
              <i className="fas fa-edit" />
            </div>
          </Button>
        </div>
      ) // Custom cell components!
    });
  }

  const onChangePageGetData = state => {
    if (state.page !== activePage) {
      // alert("on page change you have to call api and get data");
    }
  };

  function getList(
    field = "created_at",
    sortBy = "DESC",
    search = "",
    page = "1"
  ) {
    const params = {
      sort_by: field,
      order: sortBy,
      search: search,
      page: page,
      group_id: hasParam
    };
    setLoader(true);
    GroupServices.benefitPeriodList(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          settblData(data.data.rows);
          setPages(Math.ceil(data.data.count / TABLE.LIMIT));
          setLoader(false);
        } else {
          if (toaster.current) toaster.current.error(data.message);
        }
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.response);
      });
  }

  return (
    <div>
      <div className="module-header">
        <div className="flex-1 fs-16 demi-bold-text"></div>
        <div>
          {hasAccess(
            MODULE_NAMES.GROUP_BENEFIT,
            PERMISSION_TYPE.ADD,
            permissions
          ) ? (
            <Button
              className="c-btn c-primary ma-5"
              onClick={() => formAction("add")}
            >
              <i className="fas fa-plus mr-10" />
              Add Benefit Period
            </Button>
          ) : (
            ""
          )}
        </div>
      </div>
      <ReactTable
        style={{
          border: "none",
          boxShadow: "none"
        }}
        data={tblData}
        columns={columns}
        defaultPageSize={10}
        minRows={2}
        manual
        defaultFilterMethod={(filter, row) => {
          const id = filter.pivotId || filter.id;

          return row[id] !== undefined
            ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
            : true;
        }}
        className="-striped -highlight custom-react-table-theme-class"
        pages={pages}
        page={activePage}
        PaginationComponent={Pagination}
        loading={loader}
        LoadingComponent={Loader}
        onFetchData={onChangePageGetData}
        onPageChange={pageIndex => {
          setActivePage(pageIndex);
          getList(field, sortBy, searchText, pageIndex + 1);
        }}
        onSortedChange={sortProperties => {
          const sort = sortProperties[0].desc ? "DESC" : "ASC";
          setSortBy(sort);
          setActivePage(0);
          setField(sortProperties[0].id);
          getList(sortProperties[0].id, sort, searchText, 1);
          // alert("sort handler", sortProperties);
          // const orderByDirection = sortProperties[0].desc ? 1 : 0;

          // updateMapStateInfoOrderByColumn(sortProperties[0].id, orderByDirection);
        }}
      />
      <Toaster ref={toaster} />
      <CommonModel
        modal={modal}
        toggle={toggle}
        children={
          <BenefitPeriodModal
            onSubmit={submitFormHandler}
            editedData={editedData}
            action={editedData ? "edit" : "add"}
            toggle={toggle}
            {...props}
          />
        }
        header={editedData ? "Edit Benefit Period" : "Add Benefit Period"}
      />
    </div>
  );
};
export default withRouter(BenefitPeriodTable);
